import React from "react";
import TextField from "shared/components/Input/TextField";
import { Container, Row } from "reactstrap";

const TextFieldComponent = () => {
  return (
    <Container>
      <Row style={{ justifyContent: "space-evenly" }}>
        <TextField placeholder="Standard" type="standard" />
        <TextField placeholder="Outline" type="outline" />
        <TextField placeholder="Fill" type="fill" />
        <TextField
          placeholder="Outline"
          type="outline"
          readonly
          value="Read Only"
        />
        <TextField placeholder="Text Area" type="outline" textArea />
      </Row>
    </Container>
  );
};

export default TextFieldComponent;
